export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11488.3e8a7103.jpg";